<template>
  <ds-blankslate
    illustration="status-approved"
    title="Agora você pode registrar alocações e retenções diretamente na Conta Azul!">
    <ds-text>
      Efetue a alocação de seus funcionários e registre os respectivos valores de retenção de INSS.
    </ds-text>
    <template slot="actions">
      <ds-button theme="primary" @click="openRegisterRollover">Nova Alocação</ds-button>
    </template>
  </ds-blankslate>
</template>

<script>
import ServiceTakerAllocationRollover from './modal/ServiceTakerAllocationRegisterRollover.vue';

export default {
  name: 'ServiceTakerAllocationBlankslate',
  methods: {
    openRegisterRollover() {
      ServiceTakerAllocationRollover.open({}, {
        on: {
          'refresh-list': this.triggerPeriodChangeAndOpenList,
        },
      });
    },
    triggerPeriodChangeAndOpenList(period) {
      this.$emit('period-change', period);
    },
  },
};
</script>
